/**
 * Checks if a saved list record is an Express Enroll list.
 * Express Enroll lists have the expressEnrollEligible filter set to true.
 *
 * @param {Object} record - The saved list record
 * @param {string|Object} record.params - The params containing filters (can be JSON string or object)
 * @returns {boolean} True if the list is an Express Enroll list
 */
export const isExpressEnrollList = (record) => {
  try {
    const params = typeof record?.params === "string" ? JSON.parse(record?.params) : record?.params;
    return params?.filters?.expressEnrollEligible === true;
  } catch {
    return false;
  }
};
